import { render, staticRenderFns } from "./AdjustmentEvents.vue?vue&type=template&id=351bc2f7&scoped=true"
import script from "./AdjustmentEvents.vue?vue&type=script&lang=js"
export * from "./AdjustmentEvents.vue?vue&type=script&lang=js"
import style0 from "./AdjustmentEvents.vue?vue&type=style&index=0&id=351bc2f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351bc2f7",
  null
  
)

export default component.exports